(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsen-link/assets/javascripts/tipsen-link.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsen-link/assets/javascripts/tipsen-link.js');
"use strict";

const _excluded = ["disabled", "to", "children", "Component"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link,
  useLocation = _ReactRouterDOM.useLocation;
const useAppendedPersistedSearchParams = svs.components.tipsen.tipsen_link.useAppendedPersistedSearchParams;
const useUrlWithSearchParams = to => {
  let linkTo = {};
  const location = useLocation();
  if (typeof to === 'function') {
    to = to(location);
  }
  let providedSearchParamsString;
  if (typeof to === 'object') {
    linkTo = to;
    if (to.search) {
      providedSearchParamsString = to.search;
    }
  } else if (typeof to === 'string') {
    const _to$split = to.split('#'),
      _to$split2 = _slicedToArray(_to$split, 2),
      toWithoutHash = _to$split2[0],
      hash = _to$split2[1];
    linkTo.hash = hash;
    if (toWithoutHash.includes('?')) {
      const _toWithoutHash$split = toWithoutHash.split('?'),
        _toWithoutHash$split2 = _slicedToArray(_toWithoutHash$split, 2),
        pathname = _toWithoutHash$split2[0],
        search = _toWithoutHash$split2[1];
      providedSearchParamsString = search;
      linkTo.pathname = pathname;
    } else {
      linkTo.pathname = toWithoutHash;
    }
  }
  const finalSearchParams = useAppendedPersistedSearchParams(providedSearchParamsString);
  if (finalSearchParams.toString().length > 0) {
    linkTo.search = "?".concat(finalSearchParams.toString());
  }
  return linkTo;
};
const TipsenLink = _ref => {
  let disabled = _ref.disabled,
    to = _ref.to,
    children = _ref.children,
    _ref$Component = _ref.Component,
    Component = _ref$Component === void 0 ? Link : _ref$Component,
    props = _objectWithoutProperties(_ref, _excluded);
  const linkTo = useUrlWithSearchParams(to);
  if (disabled) {
    return React.createElement("div", props, children);
  }
  const toProp = {};
  if (Component === 'a') {
    toProp.href = linkTo;
  } else {
    toProp.to = linkTo;
  }
  return (
    React.createElement(Component, _extends({}, toProp, props), children)
  );
};
setGlobal('svs.components.tipsen.tipsen_link.TipsenLink', TipsenLink);

 })(window);